import {
  Box,
  Button,
  Chip,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { getPayments } from '../../../../helpers/api';
import LoaderSkeleton from '../../../common/LoaderSkeleton';
import { Empty } from 'antd';
import MUIDataTable from 'mui-datatables';
import { ApprovalRounded, AttachFile, Attachment, MoreHoriz, Receipt } from '@mui/icons-material';
import AppPagination from '../../../common/AppPagination';
import { userCats } from '../../../../helpers/appstate';
import ApprovePayment from '../payment-actions/ApprovePayment';

const PaymentPending = withRouter(({ props, onPendingCount }) => {
  const { userCategory, userPermission, location } = props;
  const searchParams = new URLSearchParams(location?.search);

  const status = searchParams.get('status') || '';
  const facilityId = searchParams.get('facilityId') || '';
  const year = searchParams.get('year') || 'all';
  const referenceNo = searchParams.get('referenceNo') || '';
  const invoiceId = searchParams.get('invoiceId') || '';
  const paymentMethod = searchParams.get('paymentMethod') || '';
  const paymentGateWay = searchParams.get('paymentGateWay') || '';

  const canApprovePayment = userPermission?.includes('APPROVE_PAYMENT');

  const [payments, setPayments] = useState([]);
  const [paymentRow, setPaymentRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialogApprove, setDialogApprove] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);

  const pageSize = 10;

  const [menuAnchor, setMenuAnchor] = useState(null);
  // console.log(pendingCount)

  useEffect(() => {
    fetchPayments();
  }, [facilityId, referenceNo, invoiceId, status, year, paymentMethod, paymentGateWay]);

  useEffect(() => {
    if (refresh) {
      fetchPayments();
    }
  }, [refresh, facilityId, referenceNo, invoiceId, status, year, paymentMethod, paymentGateWay]);


  const fetchPayments = () => {
    setLoading(true);
    getPayments(
      facilityId,
      referenceNo,
      invoiceId,
      status,
      year === 'all' ? '' : year,
      paymentMethod,
      paymentGateWay,
      pageNum,
      pageSize
    )
      .then((res) => {
        const responseData = res?.result?.data;
        setPayments(responseData);
        onPendingCount(responseData?.length);
        // setPendingCount(responseData?.length);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setRefresh(false);
      });
  };

  const handleOpenMenu = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleContentRendering = () => {
    if (loading) {
      return (
        <Box sx={{ padding: '1rem 0' }}>
          <LoaderSkeleton />
          <br />
          <LoaderSkeleton />
          <br />
          <LoaderSkeleton />
        </Box>
      );
    } else {
      if (payments?.length < 1) {
        return (
          <Box
            sx={{
              height: '60vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Empty description="No payment is await approval" />
          </Box>
        );
      } else {
        return renderContent();
      }
    }
  };

  const renderContent = () => {
    const columns = [
      {
        name: 'approvalDate',
        label: 'Paid Date',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const paymentDate = payments[index]?.paymentDate;
            return (
              <Typography variant="body2">
                {new Date(paymentDate).toLocaleDateString('en-NG', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                })}
              </Typography>
            );
          },
        },
      },
      {
        name: 'amount',
        label: 'Expected',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const amount = payments[index]?.amount;
            return (
              <Typography variant="body2" sx={{}}>
                {Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(amount)}
              </Typography>
            );
          },
        },
      },
      {
        name: 'amountPaid',
        label: 'Paid',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const paid = payments[index]?.amountPaid;
            const receipt = payments[index]?.paymentReceipt;
            return (
              <Stack direction={'flex'} spacing={0.5} alignItems={'center'}>
                <Typography variant="body2" sx={{}}>
                  {Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(paid)}
                </Typography>
                {receipt && (
                  <Tooltip title="View receipt">
                    <IconButton
                      size="small"
                      onClick={() => {
                        window.open(receipt);
                      }}
                    >
                      <AttachFile fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            );
          },
        },
      },
      {
        name: 'facilityName',
        label: 'Facility',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const facility = payments[index]?.facilityName;
            return (
              <Typography
                variant="body2"
                sx={{
                  //border: 1,
                  width: '150px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                }}
              >
                {facility}
              </Typography>
            );
          },
        },
      },
      {
        name: 'invoiceTitle',
        label: 'Invoice',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const title = payments[index]?.reportTitle;
            return (
              <Typography
                variant="body2"
                sx={
                  {
                    //border: 1,
                    // width: '200px',
                    // overflow: 'hidden',
                    // textOverflow: 'ellipsis',
                    // display: '-webkit-box',
                    // WebkitBoxOrient: 'vertical',
                    // WebkitLineClamp: 1,
                  }
                }
              >
                {title}
              </Typography>
            );
          },
        },
      },
      {
        name: 'verificationStatus',
        label: 'Status',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            let color = '';

            const status = payments[index]?.verificationStatus;
            let displayTxt = status;

            // if (status === 'PENDING') {
            //   color = 'warning';
            //   displayTxt = 'Pending';
            // }
            if (status === 'AWAITING_APPROVAL') {
              color = 'warning';
              displayTxt = 'Awaiting Approval';
            }
            if (status === 'APPROVED') {
              color = 'success';
              displayTxt = 'Approved';
            }
            return <Chip label={displayTxt} color={color} size="small" />;
          },
        },
      },
      //   {
      //     name: 'facilityName',
      //     label: 'Facility',
      //     options: {
      //       customHeadLabelRender: (a) => {
      //         return (
      //           <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
      //             {a.label}
      //           </Typography>
      //         );
      //       },
      //       customBodyRenderLite: (index) => {
      //         const facility = payments[index]?.facilityName;
      //         return (
      //           <Stack direction="column">
      //             <Typography
      //               variant="body2"
      //             >
      //               {facility}
      //             </Typography>
      //           </Stack>
      //         );
      //       },
      //     },
      //   },
      {
        name: '',
        label: 'Channel',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            const paymentMethod = payments[index]?.paymentMethod;
            const paymentGateway = payments[index]?.paymentGateway;
            return (
              <Typography variant="body2">
                {paymentMethod} {paymentGateway && <span> | {paymentGateway}</span>}
              </Typography>
            );
          },
        },
      },

      // {
      //   name: '',
      //   label: '',
      //   options: {
      //     customBodyRenderLite: (index) => {
      //       const rowItem = payments[index];
      //       return renderMenu(rowItem);
      //     },
      //   },
      // },
    ];

    if (userCategory === userCats.EDM && canApprovePayment) {
      columns.push({
        name: '',
        label: 'Action',
        options: {
          customHeadLabelRender: (a) => {
            return (
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {a.label}
              </Typography>
            );
          },
          customBodyRenderLite: (index) => {
            return (
              <Button
                size="small"
                onClick={() => {
                  setPaymentRow(payments[index]);
                  setDialogApprove(true);
                }}
                sx={{ bgcolor: 'primary.light', textTransform: 'none', color: '#FFFFFF' }}
              >
                Approve
              </Button>
            );
          },
        },
      });
    }

    return (
      <MUIDataTable
        title=""
        data={payments}
        columns={columns}
        options={{
          elevation: 0,
          search: false,
          filter: false,
          download: false,
          print: false,
          viewColumns: false,
          selectableRows: 'none',
          responsive: 'standard',
          pagination: false,
          setRowProps: (ev, dataIndex) => {
            return {
              style: dataIndex % 2 === 0 ? { background: '#f5f7ff' } : { background: '#FFFFFFF' },
            };
          },
          setTableProps: () => ({
            size: 'small',
          }),
        }}
      />
    );
  };

  const renderMenu = (item) => {
    return (
      <Box>
        <IconButton
          onClick={(event) => {
            handleOpenMenu(event);
            setPaymentRow(item);
          }}
        >
          <MoreHoriz />
        </IconButton>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          //   transformOrigin={{}}
          slotProps={{
            paper: {
              sx: {
                boxShadow: 'none',
                filter: 'drop-shadow(0px 1px 1px rgba(200, 200, 200, 0.25))',
                width: '200px',
                border: '1px solid lightgray',
              },
            },
          }}
        >
          <ListItemButton sx={{ padding: '0.5rme 1rem' }}>
            <ListItemIcon>
              <ApprovalRounded fontSize="small" />
            </ListItemIcon>
            <ListItemText
              sx={{ ml: '-20px' }}
              primary={<Typography variant="body2">Approve Payment</Typography>}
            ></ListItemText>
          </ListItemButton>
        </Menu>
      </Box>
    );
  };

  return (
    <Box>
    

      {handleContentRendering()}

      <br />
      <AppPagination
        defaultCurrent={1}
        defaultPageSize={pageSize}
        total={total}
        onPageChange={(pageNumber) => {
          setPageNum(pageNumber);
        }}
      />

      {dialogApprove && (
        <ApprovePayment
          open={dialogApprove}
          onClose={() => {
            setDialogApprove(false);
            setRefresh(true);
          }}
          payment={paymentRow}
        />
      )}
    </Box>
  );
});

export default PaymentPending;
